<template>
    <div class="main-content">
        <!-- BradCrumb header Start-->
        <section class="inner-header-bg">
            <div class="container">
                <!-- Breadcrumb Start-->
                <div class="section-breadcrumb">
                    <div class="container">
                        <div class="row">
                            <div class="col-md-12 justify-content-center align-self-center pb-2">
                                <div class="breadcrumb-content">
                                    <div class="title-section">
                                        <h1 class="title text-center text-white">Events</h1>
                                    </div>
                                    <div class="breadcrumb-nav">
                                        <ul class="breadcrumb-link text-center list-unstyled mb-0">
                                            <li class="text-white">
                                                <i class="mdi mdi-home theme-light-color pr-2"></i>
                                                <a href="index.html">Home</a>
                                            </li>
                                            <li class="theme-light-color active">Events</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- Breadcrumb End -->
            </div>
        </section>
        <!-- BradCrumb header End -->
        <!-- Blog Grid Section Start -->
        <section class="section">
            <div class="container">
                <div class="blog-post-grid">
                    <div class="row">
                        <!-- Start Blog Item -->
                        <div class="col-md-6 col-lg-4" v-for="(data,index) in newsitems" :key="index">
                            <div class="blog-item border mb-5">
                                <router-link class="blog-post-image" to="#">
                                      <img :src="data.image.url" alt="blog-img" class="img-fluid w-100">
                                </router-link>
                                <div class="blog-post-info">
                                    <h4 class="blog-post-title">
                                        <router-link class="text-dark">
                                            {{data.title}}
                                        </router-link>
                                    </h4>
                                    <p> {{data.summary}} </p>
                                    <div class="post-event d-flex align-items-center">
                                        <a href="#" class="blog-info-meta text-dark">{{data.date}}</a>
                                        <a href="#" class="blog-category text-dark">{{data.category}}</a>
                                    </div>
                                    <router-link class="blog-read-more"  :to="{name: 'News', params: { id: data.shorttitle, image: data.image.url, text:data.text.html, title:data.title, summary:data.summary, date:data.date },}">
                                        <i class="mdi mdi-arrow-right"></i>
                                    </router-link>                                  
                                </div>
                            </div>
                        </div>
                        <!-- End Blog Item -->
                    </div>
                </div>
            </div>
        </section>
        <!-- Blog Grid Section End -->
    </div>
</template>
<script>
import { gql } from 'graphql-request'

    export default {
        name: 'blog',
		data() {
	  return {
		  newsitems: []
	  }
  	},
	async created () {
    const data = await this.$graphcms.request(
      gql`
        {
          eventitems {
            title
			shorttitle
            date
            summary
			text {
				raw
				html
				markdown
				text
			}
			category
            image {
              url
            }
          }
        }
      `
    )
    this.newsitems = data.eventitems
  	},
        mounted() {
            this.init();
        },
        methods: {
            init() {
                this.initFooterHeight();
            },
            initFooterHeight() {
                var footerHeight = $("footer").outerHeight();
                $('.main-content').css('margin-bottom', footerHeight);
            },
        }
    }
</script>